import type { ReactNode } from "react";

const Check = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
);
const Cross = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--color-fg-tertiary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.4"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
);
const Small = ({ children }: { children: ReactNode }) => (
  <span className="text-[9px] text-[var(--color-fg-tertiary)]">{children}</span>
);

const rows: { label: string; cols: ReactNode[] }[] = [
  { label: "What they do", cols: [<Small>AI SaaS for law firms</Small>, <Small>Practice management software</Small>, <Small>Acquire firms, cut costs</Small>, <Small>Acquire firms, deploy AI agents</Small>] },
  { label: "Revenue", cols: [<Small>$190M ARR</Small>, <Small>$200M ARR</Small>, <Small>Varies</Small>, <span className="text-[9px] text-[var(--color-fg-tertiary)] italic">Pre-revenue</span>] },
  { label: "Owns the firm", cols: [<Cross />, <Cross />, <Check />, <Check />] },
  { label: "Owns AI platform", cols: [<Check />, <Small>Limited</Small>, <Cross />, <Check />] },
  { label: "Data flywheel", cols: [<Cross />, <Cross />, <Cross />, <Check />] },
  { label: "Can be displaced", cols: [<Check />, <Check />, <Check />, <Cross />] },
  { label: "Key weakness", cols: [<Small>SaaS model locks it out of ownership</Small>, <Small>Tool provider, no operational control</Small>, <Small>No proprietary technology</Small>, <Small>Early stage, unproven at scale</Small>] },
];

const headers = ["Harvey", "Clio", "PE Roll-Ups", "COSX"];

export function V2CompetitiveLandscapeSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <h2 className="text-[32px] font-light tracking-tight mb-1 font-[family-name:var(--font-heading)]">
        Different from everyone else in the market.
      </h2>
      <p className="text-[13px] text-[var(--color-fg-secondary)] font-light mb-5">
        Most AI legal companies sell software. Most roll-ups don&apos;t build technology. COSX does both.
      </p>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-[11px]">
          <colgroup>
            <col style={{ width: "18%" }} />
            <col style={{ width: "20.5%" }} />
            <col style={{ width: "20.5%" }} />
            <col style={{ width: "20.5%" }} />
            <col style={{ width: "20.5%" }} />
          </colgroup>
          <thead>
            <tr>
              <th className="py-2 px-3" />
              {headers.map((h, i) => (
                <th
                  key={h}
                  className={`py-2 px-3 text-center text-[10px] font-[family-name:var(--font-mono)] font-bold uppercase tracking-wider ${
                    i === 3
                      ? "bg-[var(--color-accent)] text-white rounded-t-sm"
                      : "text-[var(--color-fg-tertiary)]"
                  }`}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r, ri) => (
              <tr key={r.label} className={ri < rows.length - 1 ? "border-b border-[var(--color-border)]" : ""}>
                <td className="py-2 px-3 text-[10px] font-[family-name:var(--font-mono)] text-[var(--color-fg-tertiary)] uppercase tracking-wider">
                  {r.label}
                </td>
                {r.cols.map((cell, ci) => (
                  <td
                    key={ci}
                    className={`py-2 px-3 text-center ${
                      ci === 3 ? "bg-[var(--color-accent)]/5 border-x border-[var(--color-accent)]/20" : ""
                    } ${ci === 3 && ri === rows.length - 1 ? "border-b border-[var(--color-accent)]/20 rounded-b-sm" : ""}`}
                  >
                    <div className="flex items-center justify-center">{cell}</div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
          Harvey proved legal AI is a $11B opportunity. Clio proved small firms will pay for tools. PE proved the roll-up works.
        </p>
        <p className="text-[12px] font-medium text-[var(--color-fg)] mt-0.5">
          COSX is built to capture all three value layers: own the firm, own the platform, own the data.
        </p>
      </div>
    </div>
  );
}
